
const initialState = {
    booleanStatsModalIsOpen: false,
    booleanFeedbackModalIsOpen: false,
    booleanSocialMediaModalIsOpen: false,
    CID: 'empty',
    LID: 'empty',
    booleanStatsModalMenuIsOpen: false,
    screen: 'first',
    booleanReliabilityData: false,
    ReliabilityDiagramData: {},
    booleanChatModalIsOpen: false,

}

const dashboardReducer = (state = initialState, action) => {

    switch (action.type) {

        case 'CHANGE_DASHBOARD_MODAL':

            return {
                ...state,
                booleanStatsModalIsOpen: action.booleanStatsModalIsOpen,
                booleanFeedbackModalIsOpen: action.booleanFeedbackModalIsOpen,
                booleanStatsModalMenuIsOpen: action.booleanStatsModalMenuIsOpen,
                booleanSocialMediaModalIsOpen: action.booleanSocialMediaModalIsOpen,
                screen: action.screen,
            }

        case 'DISPLAY_CHAT_MODAL':

            return{
                ...state,
                booleanChatModalIsOpen: action.booleanChatModalIsOpen,
            }


        case 'STATS_ACCORDIAN_MENU':

            return {
                ...state,
                CID: action.CID,
                LID: action.LID,
                screen: action.screen,
            }

        case 'STATS_ACCORDIAN_MENU_IS_OPEN':


            return {
                ...state,
                booleanStatsModalMenuIsOpen: action.booleanStatsModalMenuIsOpen,
                screen: action.screen,
            }

        case 'STATS_MODAL_SCREEN_SHIFT':

        return{
            ...state,
            screen: action.screen,
            booleanReliabilityData: action.booleanReliabilityData,
            ReliabilityDiagramData: action.ReliabilityDiagramData,
        }

        case 'STATS_MODAL_SCREEN_SHIFT_LIMITED_DATA':

        return{
            ...state,
            screen: action.screen,
        }

        case 'SINGLE_CALIBRATION_API':

        return{
            ...state,
            ReliabilityDiagramData: action.ReliabilityDiagramData,
        }
            
        default:
            return state;
    }
    
}


export default dashboardReducer
